import { NumberFormatValues, SourceInfo } from 'react-number-format';
import { useCallback } from 'react';
import { useQuoteBuilderActions } from '@paradigm/features/src/unified-rfqs/ui/grfq/quote-builder/form-context';
import { useQuoteBuilderView } from '@paradigm/features/src/unified-rfqs/ui/grfq/quote-builder/view';
import QuantityInputTooltip from '#/components/UnifiedRfqs/quote-builder/QuantityInputTooltip';
import Input from '@paradigm/design-system/src/components/Input';
import { useSubmitted } from '@paradigm/features/src/forms/submitted-context';
import useIsMobile from '@paradigm/design-system/src/hooks/useIsMobile';
import { useDebouncedTrackAction } from '@paradigm/features/src/analytics';

function QuantityField() {
  const { quantity, fieldsValidation, legs, side } = useQuoteBuilderView();
  const { changeQuantity } = useQuoteBuilderActions();
  const isValid = fieldsValidation.quantity;
  const { didSubmit } = useSubmitted();
  const isMobile = useIsMobile();
  const trackAction = useDebouncedTrackAction();
  const handleOnChange = useCallback(
    ({ formattedValue }: NumberFormatValues, sourceInfo: SourceInfo): void => {
      if (sourceInfo.source === 'event')
        trackAction('change strategy quantity', { side });
      changeQuantity(formattedValue);
    },
    [changeQuantity, side, trackAction],
  );
  return (
    <Input
      id="grfq-quote-builder-quantity-input"
      data-testid="grfq-quote-builder-quantity-input"
      label={<QuantityInputTooltip />}
      value={quantity.value}
      size={isMobile ? 'large' : 'medium'}
      inputType="numeric"
      warning={!isValid && didSubmit}
      inputMode="decimal"
      decimalScale={quantity.precision}
      thousandSeparator
      suffix={legs[0]?.contractCurrency}
      allowNegative={false}
      onValueChange={handleOnChange}
    />
  );
}

export default QuantityField;
